<div id="{{chartSettings.name}}" class="options-chart"></div>
